import { Component,inject, forwardRef, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, Validator, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { SharedSignalsService } from '../../services/shared-signals.service';


@Component({
    selector: 'taly-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrls: ['./custom-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CustomSelectComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomSelectComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);

  @Input( { required : true } ) id: string = '';
  @Input( { required : true } ) label: string = '';
  @Input( { required : true } ) options : any[] = [];
  @Input( { required : false } ) optionsValue! : string;
  @Input( { required : false } ) optionsLabel! : string;
  @Input() placeholderText?:string = '';
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() min! : number;
  @Input() max! : number
  showErrorMessages : boolean = false;
  textDirection:string;
  @Input() set isDisabled(disable: boolean) {
    this.disabled = disable;
  }

  disabled = false;

  get f() {
    return this.formGroup?.controls;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.textDirection = this.transferSignal.textDirection()

  }

  ngOnInit(): void {
    
  }

  private _value:  any | null = null; 

  set value(value: any) {
    this._value = value;
    this.onChange(value);
  }

  get value(): any {
    return this._value;
  }

  onChange(event:any){
  
  }

  onReset(event:any){
    event.inputField = null;
    this._value = null
  }

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }

    if (this.formGroup && this.controlName) {
      this.formGroup.get(this.controlName)?.setValue(value); // Set the value in the form control
    }
  
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // Implement the validator function
  validate(control: AbstractControl) {
    // if (control.value !== null && (isNaN(control.value) || control.value < 10 || control.value > 100)) {
    //   return { invalidRange: true };
    // }
    return null;
  }
  
  onHide( event:any ){
    this.showErrorMessages = true;
  }
}
